import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set initial dark mode background before React renders to prevent flash
// Only run in browser environment (not during SSR/build)
if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
  const savedDarkMode = localStorage.getItem('darkMode');
  if (savedDarkMode === 'true' && document && document.body) {
    document.body.style.backgroundColor = '#111827';
    document.documentElement.style.backgroundColor = '#111827';
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
